import { render, staticRenderFns } from "./AvSkeletonVerticalNavMenu.vue?vue&type=template&id=17e40616"
import script from "./AvSkeletonVerticalNavMenu.vue?vue&type=script&lang=ts"
export * from "./AvSkeletonVerticalNavMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports